import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/useAuth";
import { getHomePathForRole } from "../utils/roleHome";

// Oposto do PrivateRoute: páginas só para visitantes (landing, login, registro).
// Usuário logado é redirecionado para seu "home" por papel.
export function GuestRoute({ children }) {
  const { token, isAdmin, isPaid } = useAuth();

  if (token) {
    return <Navigate to={getHomePathForRole({ isAdmin, isPaid })} replace />;
  }

  return children;
}
